/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserContextInputCurrentModule } from './userContextInputCurrentModule';
import type { UserContextInputActivity } from './userContextInputActivity';

/**
 * Shows what the user is currently working on
Projection of the last activities
 */
export interface UserContextInput {
  currentModule?: UserContextInputCurrentModule;
  activity?: UserContextInputActivity;
}
